import React, { useState, useEffect } from 'react'
import { Wifi, WifiOff, AlertCircle } from 'lucide-react'
import { cn } from '../utils/cn'

export default function ConnectionStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setShowWarning(false)
    }

    const handleOffline = () => {
      setIsOnline(false)
      setShowWarning(true)
    }

    // Listen for online/offline events
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Check for Firebase connection issues
    const checkFirebaseConnection = () => {
      // This is a simple check - in a real app you might want to ping Firebase
      const hasConnectionIssues = sessionStorage.getItem('firebase_connection_issues')
      if (hasConnectionIssues && isOnline) {
        setShowWarning(true)
      }
    }

    checkFirebaseConnection()

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [isOnline])

  if (!showWarning && isOnline) {
    return null
  }

  return (
    <div className={cn(
      "fixed top-4 inset-x-4 sm:inset-x-auto sm:right-4 z-50 transition-all duration-300",
      showWarning ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"
    )}>
      <div className={cn(
        "mx-auto sm:mx-0 max-w-md flex items-center space-x-2 px-4 py-2 rounded-lg shadow-lg border",
        isOnline 
          ? "bg-yellow-50 border-yellow-200 text-yellow-800" 
          : "bg-red-50 border-red-200 text-red-800"
      )}>
        {isOnline ? (
          <>
            <AlertCircle className="h-4 w-4" />
            <span className="text-sm font-medium">Connection issues detected</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span className="text-sm font-medium">You're offline</span>
          </>
        )}
      </div>
    </div>
  )
} 